import { createReducer, on } from "@ngrx/store";
import { raceDataModel } from "@sports-models/index";
import * as SportsbookActions from "../../../stores/sportsbook/sportsbook.actions";

export interface SportsbookCommonState {
  raceData: raceDataModel;
}

export const initialState: raceDataModel = {
  filters: [
    {
      index: 0,
      name: "Proximamente",
      navigate: "next",
    },
    {
      index: 1,
      name: "Hoy",
      navigate: "todayPaddock",
    },
    {
      index: 2,
      name: "Mañana",
      navigate: "tomorrowPaddock",
    },
  ],
  selectedFilter: null,
  next: [],
  today: [],
  tomorrow: [],
};

export const SportsbookRaceReducer = createReducer(
  initialState,
  // Race
  on(SportsbookActions.setRace, (state, raceData: raceDataModel) => ({
    ...state,
    ...raceData,
  })),
  on(SportsbookActions.clearRace, (state) => ({
    ...state,
    ...initialState,
  })),
);
